export const titleAndSubTitleClasses = {
    title: 'BinoTitle_title',
    subTitle: 'BinoTitle_subTitle',
};
